
import { defineComponent } from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  name: 'Header',
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    FontAwesomeIcon
  },
  props: {
    userData: {
      type: Object,
      required: false
    },
    displayName: {
      type: String,
      required: false
    },
    avatar: {
      type: String,
      required: false
    },
    additionalButtons: {
      type: Array,
      required: false,
      default: () => []
    },
    logOutFunction: {
      type: Function,
      required: true
    },
    haveSidebar: {
      type: Boolean,
      required: false,
      default: false
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      logOutIcon: faSignOutAlt
    }
  },
  methods: {
    getDisplayName () {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const [first, ...rest] = this.displayName!.split(' ')
      const last = rest.pop()

      return [first, ...rest.map((n) => `${n[0]}.`), last].join(' ')
    },
    getDisplayNameMobile () {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const [first] = this.displayName!.split(' ')

      return first.substring(0, 8)
    }
  }
})
